import { DownloadControllerService } from "openapi";
import authorizedCall from "./authorizedCall";

export async function downloadPDF(
  fileName: string,
  defaultFilename = "example.pdf"
) {
  return fetchPDF(fileName)
    .then((blob) => {
      const filename = !fileName ? defaultFilename : fileName; //getFilenameFromResponseHeaders(blob, defaultFilename);
      downloadBlobAsFile(blob, filename);
    })
    .catch((error) => {
      console.error("Error downloading PDF: ", error);
    });
}

export async function fetchPDF(filename: string) {
  return authorizedCall(DownloadControllerService.download, { filename }, true)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error(error);
      throw new Error("Network response was not ok");
    });
}

export function getFilenameFromResponseHeaders(
  blob: Blob,
  defaultFilename: string
) {
  const contentDisposition =
    blob.type === "application/json" ? null : blob.type;
  let filename = defaultFilename;

  if (contentDisposition) {
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(contentDisposition);
    if (matches != null && matches[1]) {
      filename = matches[1].replace(/['"]/g, "");
    }
  }

  return filename;
}

export function downloadBlobAsFile(blob: Blob, filename: string) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.setAttribute("style", "display:none;");
  document.body.appendChild(a);
  a.href = url;
  a.download = filename;
  a.click();
  a.remove();
}
